import axios from 'axios';
import { Http } from '@app/base';
import { ClippoHttp } from '@webinex/clippo';
import { VRowMeta, VRowData } from './commonTypes';

const axiosInstance = axios.create({ baseURL: '/api/clippo' });

axiosInstance.interceptors.request.use(async (request) => {
  const { key, value } = await Http.getAuthHeader();
  request.headers![key] = value;
  return request;
});

export const clippoHttp = new ClippoHttp<VRowMeta, VRowData>(axiosInstance);
